import React from 'react';
import {ProvidedGlobalProps, withGlobalProps} from '../../../providers/globalPropsProvider';
import {LazyRichContentViewer} from '../../RichContentViewer/LazyRichContentViewer';
import {SPECS} from '../../../specs';
import {isRicoRichContent} from '../../RichContentViewer/utils';
import {useExperiments} from '@wix/yoshi-flow-editor';
import {InfoSectionDescription as InfoSectionDescriptionOld} from './InfoSectionDescriptionOld/InfoSectionDescription';

export enum DataHook {
  Description = 'info-section-description',
}
export interface InfoSectionDescriptionProps extends ProvidedGlobalProps {
  description: string;
  index: number;
}

export const InfoSectionDescription: React.FC<InfoSectionDescriptionProps> = withGlobalProps(
  (props: InfoSectionDescriptionProps) => {
    const {description, index} = props;
    const {experiments} = useExperiments();
    const shouldRenderRico =
      experiments.enabled(SPECS.PRODUCT_PAGE_RICO_DESCRIPTION) &&
      (isRicoRichContent(description) || experiments.enabled(SPECS.PRODUCT_PAGE_MIGRATE_TO_RICO_DESCRIPTION));

    if (!shouldRenderRico) {
      return <InfoSectionDescriptionOld description={description} index={index} />;
    }

    return (
      <LazyRichContentViewer
        key={index}
        dataHook={DataHook.Description}
        contentAsString={description}
        ricosContext={'InfoSectionDescription'}
      />
    );
  }
);
